module.exports = __webpack_public_path__ + "static/img/draw-box.8de4792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw-box.png
// module id = aHHG
// module chunks = 0